
const DisplayCryptoInFiatReducers = (state = false, action) => {
  switch (action.type) {
    case "openDisplayCryptoInFiat":
      return (state = true);
    case "closeDisplayCryptoInFiat":
      return (state = false);
    default:
      return state;
  }
};

export default DisplayCryptoInFiatReducers;
